import { useEffect, useRef, useState } from 'react'
import ConfigRepository from '@/shared/config/repository/configRepository'
import { useAppStore } from '@/shared/store'
import Config from '@/shared/config/config'

export const useConfig = () => {
    const isSkinSet = useRef(false)
    const configRepository = ConfigRepository.Instance

    const { setAppSkin, setFaq, setTAndC } = useAppStore()

    const [isConfigFetched, setIsConfigFetched] = useState(false)

    const getAndSaveAppSkinToStore = (config: Config | null | undefined) => {
        if (config) {
            const { skin } = config
            setAppSkin(skin)
        }
    }

    const takeConfigIfNeed = async () => {
        const previousLocalConfig = configRepository.getLocalConfig()
        isSkinSet.current = false

        if (previousLocalConfig) {
            isSkinSet.current = true
        }

        const config = await configRepository.takeConfigIfNeed()
        if (config) {
            setAppSkin(config.skin)
            getAndSaveAppSkinToStore(previousLocalConfig)
            setFaq(config.faqUrl)
            setTAndC(config.privacyPolicyUrl)
            isSkinSet.current = true
        }

        setIsConfigFetched(true)
    }

    useEffect(() => {
        takeConfigIfNeed()
    }, [])

    return {
        isConfigFetched,
        isSkinSet: isSkinSet.current,
        takeConfigIfNeed,
    }
}
